import React, { useEffect, useState } from "react";
import EditProfile from "./Profile";
import ClientDetails from "../Clients/components/ClientDetails";
import { useIds } from "../../hook/AdminContext";
import CircularLoader from "../../components/loader/CircularLoader";
import { get_client_details } from "../../DAL/clientTypes/ClientTpes";
import { enqueueSnackbar } from "notistack";
import { useParams } from "react-router-dom";

export default function ProfileFlowDecider() {
  const { userInfo, setBreadCrumb } = useIds();
  const { user_id } = useParams();
  const [targetProfile, setTargetProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  const handleGetClientDetails = async () => {
    const id = user_id || userInfo.profile_id;
    const resp = await get_client_details(id);
    if (resp.code == 200) {
      setTargetProfile(resp.user);
    } else {
      enqueueSnackbar(resp.message, { variant: "error" });
    }
    setLoading(false);
  };

  useEffect(() => {
    if (userInfo?.isCompanyProfile || userInfo.role == "client" || user_id) {
      handleGetClientDetails();
    } else {
      setTargetProfile(userInfo);
      setLoading(false);
    }
  }, [userInfo]);

  useEffect(() => {
    setBreadCrumb([]);
  }, []);

  if (loading) {
    return <CircularLoader />;
  }

  console.log(userInfo.role, "");
  if (
    (userInfo.role == "client" && !userInfo?.isCompanyProfile) ||
    user_id ||
    (userInfo?.isCompanyProfile &&
      userInfo?.company_access?.manage_profile?.company_profile)
  ) {
    return (
      <div className="container-fluid my-3">
        <ClientDetails
          data={targetProfile}
          fetchDetails={handleGetClientDetails}
        />
      </div>
    );
  } else {
    return (
      <>
        <EditProfile />
      </>
    );
  }
}
